// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__LKcfF","wrapper-inner":"DefaultLayout_wrapper-inner__ZFdSM","container":"DefaultLayout_container__9-y7i","content":"DefaultLayout_content__-QHqc"};